import _ from "lodash";

// Recursively checks if a value is empty, ignoring metadata fields.
const isValueEmpty = (value) => {
  if (value === null || value === undefined || value === "") return true;
  if (Array.isArray(value)) {
    return value.every(item => isValueEmpty(item));
  }
  if (typeof value === "object" && value !== null) {
    return Object.keys(value).every(key => {
      if (key === "date_created" || key === "date_changed") return true;
      return isValueEmpty(value[key]);
    });
  }
  return false;
};

/**
 * Removes empty blocks from multi-field arrays within a form's values.
 * A block is considered empty if all its fields (ignoring metadata like `date_created`)
 * are null, undefined, or an empty string. This function mutates the `values` object directly.
 * @param {object} values The form values object.
 * @param {Array} fieldDef The field definitions for the form block.
 * @returns {object} The mutated `values` object.
 */
export const cleanMultiFieldValues = (values, fieldDef) => {
  const multiFields = _.filter(fieldDef, { field_type: "multi_field" });
  multiFields.forEach(mf => {
    const fieldName = mf.field_name;
    if (Array.isArray(values[fieldName])) {
      values[fieldName] = values[fieldName].filter(block => {
        if (!block) return false;
        const relevantKeys = Object.keys(block).filter(key => key !== "date_created" && key !== "date_changed");
        return !relevantKeys.every(key => isValueEmpty(block[key]));
      });
    }
  });
  return values;
};